<template>
  <div class="text-subtitle-1"
    >{{ label }}:
    <span class="font-weight-bold">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'InvoiceDetail',
  components: {},
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {}
  },
}
</script>
